// Values of org.onboardingTodo. NULL means the todo is still shown.
export enum OnboardingTodoStatus {
  Completed = 'completed',
  Dismissed = 'dismissed',
}

// Free, personalized tour of Rolebase, offered from the onboarding todo
export const BOOK_DEMO_URL = 'https://cal.com/lonestone-godefroy/rolebase-demo'
